module.exports = __webpack_public_path__ + "static/media/airforce.2efcdc4a.png";